(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGallery = (root) => {
      if (!root || root.dataset.galleryReady === 'true') return;
      root.dataset.galleryReady = 'true';
      const slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
      const dots = Array.from(root.querySelectorAll('[data-gallery-dot]'));
      const counter = root.querySelector('[data-gallery-counter]');
      const previous = root.querySelector('[data-gallery-previous]');
      const next = root.querySelector('[data-gallery-next]');
      const section = root.closest('[data-product-v2]');
      const sticky = section && section.querySelector('[data-product-sticky]');
      let active = 0;
      const show = (index) => {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const selected = i === active;
          slide.hidden = !selected;
          slide.classList.toggle('is-active', selected);
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === active)));
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
        if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
        if (thumbs[active]) thumbs[active].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      };
      if (previous) previous.addEventListener('click', () => show(active - 1));
      if (next) next.addEventListener('click', () => show(active + 1));
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.index))));
      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.index))));
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') show(active - 1);
        if (event.key === 'ArrowRight') show(active + 1);
      });
      let swipeStart = null;
      root.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') swipeStart = { x: event.clientX, y: event.clientY };
      });
      root.addEventListener('pointerup', (event) => {
        if (!swipeStart) return;
        const dx = event.clientX - swipeStart.x;
        const dy = event.clientY - swipeStart.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(active + (dx < 0 ? 1 : -1));
        swipeStart = null;
      });
      root.addEventListener('pointercancel', () => { swipeStart = null; });
      if (sticky && 'IntersectionObserver' in window) {
        const information = section.querySelector('.product-v2__information');
        const observer = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && window.innerWidth <= 680);
        }, { threshold: 0.05 });
        if (information) observer.observe(information);
        window.addEventListener('resize', () => {
          if (window.innerWidth > 680) sticky.classList.remove('is-visible');
        });
      }
    };
    const initVariants = (section) => {
      if (!section || section.dataset.variantReferencesReady === 'true') return;
      section.dataset.variantReferencesReady = 'true';
      const picker = section.querySelector('[data-variant-picker]');
      const references = Array.from(section.querySelectorAll('[data-variant-reference]'));
      if (!picker || !references.length) return;
      const update = () => {
        const selected = references.find((button) => button.dataset.variantId === picker.value);
        references.forEach((button) => button.setAttribute('aria-pressed', String(button === selected)));
        if (selected) {
          const gallery = section.querySelector('[data-product-gallery]');
          const thumb = gallery && gallery.querySelector(`[data-gallery-thumb][data-index="${selected.dataset.imageIndex}"]`);
          if (thumb) thumb.click();
        }
      };
      references.forEach((button) => button.addEventListener('click', () => {
        picker.value = button.dataset.variantId;
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      picker.addEventListener('change', update);
      update();
    };
    const initAll = (scope) => {
      const root = scope && scope.matches && scope.matches('[data-product-gallery]') ? scope : document;
      root.querySelectorAll('[data-product-gallery]').forEach(initGallery);
      const variantRoot = scope && scope.matches && scope.matches('[data-product-v2]') ? scope : document;
      variantRoot.querySelectorAll('[data-product-v2]').forEach(initVariants);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    else initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
